import lazyScreen from '../utils/lazyScreen';
const CAIssueRequests = lazyScreen(() => import('../pages/ca/CAIssueRequests/index.js'), 'pages/ca/CAIssueRequests/index.js');
const CAReceiveRequests = lazyScreen(() => import('../pages/ca/CAReceiveRequests/index.js'), 'pages/ca/CAReceiveRequests/index.js');
const CARequests = lazyScreen(() => import('../pages/ca/CARequests/index.js'), 'pages/ca/CARequests/index.js');
const CARequest = lazyScreen(() => import('../pages/ca/CARequest/index.js'), 'pages/ca/CARequest/index.js');
const CAIssue = lazyScreen(() => import('../pages/ca/CAIssue/index.js'), 'pages/ca/CAIssue/index.js');
const CAReceive = lazyScreen(() => import('../pages/ca/CAReceive/index.js'), 'pages/ca/CAReceive/index.js');
const CAReceives = lazyScreen(() => import('../pages/ca/CAReceives/index.js'), 'pages/ca/CAReceives/index.js');
const CAReceiveCollections = lazyScreen(() => import('../pages/ca/CAReceiveCollections/index.js'), 'pages/ca/CAReceiveCollections/index.js');
const CAIssues = lazyScreen(() => import('../pages/ca/CAIssues/index.js'), 'pages/ca/CAIssues/index.js');
const CAIssueBillPayments = lazyScreen(() => import('../pages/ca/CAIssueBillPayments/index.js'), 'pages/ca/CAIssueBillPayments/index.js');
const CATransfers = lazyScreen(() => import('../pages/ca/CATransfers/index.js'), 'pages/ca/CATransfers/index.js');
const CATransfer = lazyScreen(() => import('../pages/ca/CATransfer/index.js'), 'pages/ca/CATransfer/index.js');
const CABalances = lazyScreen(() => import('../pages/ca/CABalances/index.js'), 'pages/ca/CABalances/index.js');
const CABalance = lazyScreen(() => import('../pages/ca/CABalance/index.js'), 'pages/ca/CABalance/index.js');
const CAAdjusts = lazyScreen(() => import('../pages/ca/CAAdjusts/index.js'), 'pages/ca/CAAdjusts/index.js');
const CAAdjust = lazyScreen(() => import('../pages/ca/CAAdjust/index.js'), 'pages/ca/CAAdjust/index.js');
const CABankStatements = lazyScreen(() => import('../pages/ca/CABankStatements/index.js'), 'pages/ca/CABankStatements/index.js');
const CABankStatement = lazyScreen(() => import('../pages/ca/CABankStatement/index.js'), 'pages/ca/CABankStatement/index.js');
const CACashBook = lazyScreen(() => import('../pages/ca/CACashBook/index.js'), 'pages/ca/CACashBook/index.js');
const CACashFlows = lazyScreen(() => import('../pages/ca/CACashFlows/index.js'), 'pages/ca/CACashFlows/index.js');
const POSCashSettlements = lazyScreen(() => import('../pages/ca/POSCashSettlements/index.js'), 'pages/ca/POSCashSettlements/index.js');
const POSCashSettlement = lazyScreen(() => import('../pages/ca/POSCashSettlement/index.js'), 'pages/ca/POSCashSettlement/index.js');

export default [
    {
        path: '/ca/CARequests',
        component: CARequests
    },
    {
        path: '/ca/CAIssueRequests',
        component: CAIssueRequests
    },
    {
        path: '/ca/CAReceiveRequests',
        component: CAReceiveRequests
    },
    {
        path: '/ca/CARequest/:code',
        component: CARequest
    },
    {
        path: '/ca/CAIssues',
        component: CAIssues
    },
    {
        path: '/ca/BillPayments',
        component: CAIssueBillPayments
    },
    {
        path: '/ca/CAIssue/:code',
        component: CAIssue
    },
    {
        path: '/ca/CAReceives',
        component: CAReceives
    },
    {
        path: '/ca/Collections',
        component: CAReceiveCollections
    },
    {
        path: '/ca/CAReceive/:code',
        component: CAReceive
    },
    {
        path: '/ca/CATransfers',
        component: CATransfers
    },
    {
        path: '/ca/CATransfer/:code',
        component: CATransfer
    },
    {
        path: '/ca/CAAdjusts',
        component: CAAdjusts
    },
    {
        path: '/ca/CAAdjust/:code',
        component: CAAdjust
    },
    {
        path: '/ca/CABalances',
        component: CABalances
    },
    {
        path: '/ca/CABalance/:code',
        component: CABalance
    },
    {
        path: '/ca/CABankStatements',
        component: CABankStatements
    },
    {
        path: '/ca/CABankStatement/:code',
        component: CABankStatement
    },
    {
        path: '/ca/CACashBook',
        component: CACashBook
    },
    {
        path: '/ca/CACashFlows',
        component: CACashFlows
    },
    {
        path: '/ca/POSCashSettlements',
        component: POSCashSettlements
    },
    {
        path: '/ca/POSCashSettlement/:code',
        component: POSCashSettlement
    }
];
